import React from 'react';
import { useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/lib/useAsync';
import { useEntity, catalogApiRef, EntityRefLink } from '@backstage/plugin-catalog-react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  LinearProgress,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { Link, InfoCard } from '@backstage/core-components';

export const EntityNamespaceGroupsCard = () => {
  const { entity } = useEntity();
  const catalogApi = useApi(catalogApiRef);
  const namespace = entity.metadata.namespace || 'default';

  const { value, loading, error } = useAsync(async () => {
    const response = await catalogApi.getEntities({
      filter: {
        kind: 'Group',
        'metadata.namespace': namespace,
        'metadata.tags': 'github-org',
      },
    });
    return response.items;
  }, [catalogApi, namespace]);

  if (loading) return <LinearProgress />;
  if (error) return <Alert severity="error">{error.message}</Alert>;
  if (!value || value.length === 0) return null;

  return (
    <InfoCard title="GitHub Teams Access" noPadding>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Backstage Group</TableCell>
            <TableCell>GitHub Team</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {value.map(group => (
            <TableRow key={group.metadata.uid}>
              <TableCell>
                <EntityRefLink entityRef={group} defaultKind="Group" />
              </TableCell>
              <TableCell>
                <Link
                  to={`https://github.com/orgs/GDP-ADMIN/teams/${group.metadata.namespace}-${group.metadata.name}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GDP-ADMIN/teams/{group.metadata.namespace}-{group.metadata.name}
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </InfoCard>
  );
};
